import { useIntl } from 'react-intl';
import AccionaButton from '../../../../../../../components/AccionaButton';
import { Collapse } from 'antd';
import { useLayoutEffect, useMemo, useState } from 'react';
import { CE, EHE } from './normative';
import { PropTypes } from 'prop-types';
import InProgressPreregisterModal from '../InProgressPreregisterModal';
import AccionaSimpleModal from '../../../../../../../components/AccionaSimpleModal';
import Modal from '../../../../../../../components/AccionaModal';
import { useParams } from 'react-router-dom';
import {
  getObjectStore,
  removeFromCache,
} from '../../../../../../../indexedDB/utils';
import { PENDING_PREREGISTERS_TABLE } from '../../../../../../../indexedDB/data';

const InnerModal = ({ project, onCancel, onOk, model, setModel }) => {
  const intl = useIntl();

  const processedData = useMemo(() => {
    switch (project.normative_data.name) {
      case 'EHE':
        return EHE;
      case 'CE':
        return CE;
      default:
        return EHE;
    }
  }, [project]);

  return (
    <>
      {project.concrete_providers.length === 1 || model ? (
        <div
          style={{
            fontFamily: "'Acciona Font', sans-serif",
            color: '#f00',
            textTransform: 'uppercase',
          }}
        >
          <p>
            {intl.formatMessage(
              { id: `mandatoryFieldsContent` },
              { normative: project.normative_data.name },
            )}
          </p>
          <div id="infoNormative">
            <Collapse
              items={[
                {
                  key: 1,
                  label: intl.formatMessage({ id: `more_info` }),
                  children: processedData(),
                },
              ]}
            />
          </div>
          <div className="form-row" style={{ width: '100%' }}>
            <AccionaButton
              classIcon="icon fas fa-times"
              className="btn btn-red"
              msg={intl.formatMessage({ id: 'no' })}
              onClick={onCancel}
              style={{ marginTop: '20px', width: '120px' }}
            />
            <AccionaButton
              className="btn btn-red"
              classIcon="icon fas fa-check"
              msg={intl.formatMessage({ id: 'yes' })}
              onClick={() => onOk(model)}
              style={{ marginTop: '20px', width: '120px', float: 'right' }}
            />
          </div>
        </div>
      ) : (
        <div className="containerModelButtons">
          <AccionaButton
            className=""
            msg={intl.formatMessage({ id: 'cemex' })}
            onClick={navigator.onLine ? () => setModel('cemex') : null}
            disabled={!navigator.onLine}
          />
          <AccionaButton
            className=""
            msg={intl.formatMessage({ id: 'other' })}
            onClick={() => setModel('other')}
          />
        </div>
      )}
    </>
  );
};

const InitPreregisterModal = ({ visible, onCancel, project, onOk }) => {
  const intl = useIntl();
  const { id: pid } = useParams();
  const [model, setModel] = useState(
    project.concrete_providers.length === 1
      ? project.concrete_providers[0].provider.toLowerCase()
      : null,
  );
  const [preregisterInProgress, setPreregisterInProgress] = useState();

  useLayoutEffect(() => {
    const getPendingPreregister = async () => {
      const object = await getObjectStore(PENDING_PREREGISTERS_TABLE);
      const request = object.get(+pid);
      request.onsuccess = () => {
        if (request.result) {
          setPreregisterInProgress(request.result);
        }
      };
      return object;
    };
    getPendingPreregister();
  }, [pid]);

  if (project.concrete_providers.length === 0) {
    return (
      <Modal open={visible} onCancel={() => onCancel()}>
        <div
          className="form-row"
          style={{
            padding: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <p style={{ margin: '20px 0 30px 0', fontSize: '1.1em' }}>
            {intl.formatMessage({ id: 'preregisters.noProviders' })}
          </p>
          <AccionaButton
            msg={intl.formatMessage({ id: 'ok' })}
            onClick={onCancel}
          />
        </div>
      </Modal>
    );
  }

  if (preregisterInProgress) {
    return (
      <InProgressPreregisterModal
        open={visible}
        onCancel={() => {
          setPreregisterInProgress(undefined);
          removeFromCache(PENDING_PREREGISTERS_TABLE, +pid);
        }}
        onOk={() => onOk(preregisterInProgress.model, preregisterInProgress)}
      />
    );
  }

  return (
    <AccionaSimpleModal
      show={visible}
      onCancel={() => {
        onCancel();
        setModel(null);
      }}
      title={
        model
          ? intl.formatMessage({ id: `mandatoryFieldsTitle` })
          : intl.formatMessage({ id: `modelTitle` })
      }
      content={
        <InnerModal
          visible={Boolean(model)}
          onCancel={() => {
            onCancel();
            setModel(null);
          }}
          project={project}
          model={model}
          setModel={setModel}
          onOk={onOk}
        />
      }
    />
  );
};

InnerModal.propTypes = {
  project: PropTypes.shape({
    normative_data: PropTypes.object,
    concrete_providers: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
  model: PropTypes.string,
  setModel: PropTypes.func.isRequired,
};

InnerModal.defaultProps = {
  model: undefined,
};

InitPreregisterModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
  project: PropTypes.shape({
    normative_data: PropTypes.object,
    concrete_providers: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

InitPreregisterModal.defaultProps = {
  visible: false,
};

export default InitPreregisterModal;
